import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { SimTypes } from '@/helper/SimTypes'

const initialState = {
}

const SubstituteSimCardModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async requestSubstituteSimCard ({ commit, state, getters, rootGetters }, { productNumber, simType, mfaToken }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })

      let successMessage = 'Vielen Dank für Ihre Bestellung. Ihre Ersatz-SIM-Karte wird innerhalb der folgenden 3 Werktage verschickt.\n' +
        'Ihre alte SIM-Karte bleibt solange aktiviert, bis Sie Ihre neue Ersatz-SIM-Karte nach Erhalt online oder telefonisch über die LIDL Connect Kundenbetreuung aktivieren.\n' +
        'Falls Sie Ihre bisherige SIM-Karte sperren lassen möchten, nutzen Sue bitte die Funktion "SIM-Karte sperren"'
      let activationByCustomer = true
      if (simType === SimTypes.eSimCode) {
        activationByCustomer = false
        successMessage = 'Vielen Dank für deine Bestellung! Weitere Informationen zu deiner eSIM werden Dir in der Regel nach 2 Stunden per Mail zur Verfügung gestellt.\n' +
          'In Ausnahmefällen kann dies bis zu 24 Stunden andauern. Bitte beachte, dass bei Bereitstellung der Informationen per Mail deine alte SIM-Karte deaktiviert wird.\n' +
          'Falls du deine bisherige SIM-Karte sperren lassen möchtest, nutze bitte die Funktion "SIM sperren".'
      }

      return apolloClient.mutate({
        mutation: gql`mutation simOrder ($substituteSimCardInput: SubstituteSimCardInput!) {
          substituteSimCard (substituteSimCardInput: $substituteSimCardInput) {
            success
          }
        }`,
        variables: {
          substituteSimCardInput: {
            substituteSimCardProcess: 'MAGMA',
            productNumber: productNumber,
            activateByCustomer: activationByCustomer,
            // after successfully mfa, mfa token is needed to order the new sim
            ...(mfaToken && { mfaToken: mfaToken })
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'simOrder', { root: true })
        commit('addMessage', {
          type: 'success',
          message: successMessage
        }, { root: true })
      }).catch((error) => {
        // MFA
        const errorDetails = error?.networkError?.result?.errors?.[0]?.extensions?.details
        const token = errorDetails?.error_hints?.['X-Multifactor-Token']
        const methods = errorDetails?.error_hints?.available_methods

        if (token) commit('mfa/setToken', token, { root: true })

        if (Array.isArray(methods) && methods.length > 0) {
          commit('mfa/setMethod', methods[0], { root: true })
        } else {
          throw error
        }
      })
    },
    async activateSim ({ commit, state, getters, rootGetters }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation activateSimCard {
          activateSubstituteSimCard{success}
        }`
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'activateSimCard', { root: true })
        commit('addMessage', {
          type: 'success',
          message: 'Vielen Dank! Ihre Ersatz-SIM-Karte wurde erfolgreich zur Aktivierung vorgemerkt. Die Aktivierung dauert in der Regel ca. 30 Minuten. Dann ist Ihre neue SIM-Karte einsatzbereit. Im Zuge der Aktivierung wird die bisher genutzte SIM-Karte automatisch deaktiviert. Bitte beachten Sie, dass Ihre neue SIM-Karte einen neuen PIN hat. Den neuen PIN finden Sie unter dem SIM-Kartenträger auf Ihrem Anschreiben.'
        }, { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  }
}

export {
  SubstituteSimCardModule
}
